import {
  CHECK_BAHISTA_ANALYSIS_REQUEST,
  CHECK_BAHISTA_ANALYSIS_SUCCESS,
  CHECK_BAHISTA_ANALYSIS_FAILURE,
  GET_BAHISTA_PREDICTIONS_REQUEST,
  GET_BAHISTA_PREDICTIONS_SUCCESS,
  GET_BAHISTA_PREDICTIONS_FAILURE,
  RUN_BAHISTA_ANALYZE_REQUEST,
  RUN_BAHISTA_ANALYZE_SUCCESS,
  RUN_BAHISTA_ANALYZE_FAILURE,
  CLEAR_BAHISTA_STATE,
  GET_BAHISTA_AUTHOR_REQUEST,
  GET_BAHISTA_AUTHOR_SUCCESS,
  GET_BAHISTA_AUTHOR_FAILURE,
} from 'Store/constants';
import {
  checkUserBahistaAnalysis as checkUserBahistaAnalysisApi,
  fetchBahistaPredictions as fetchBahistaPredictionsApi,
  runBahistaAnalyze as runBahistaAnalyzeApi,
  fetchBahistaAuthor as fetchBahistaAuthorApi,
} from 'Pages/MatchCard/Tabs/BahistaTab/bahistaApi';

export const checkUserBahistaAnalysis = (eventId, { customerId } = {}) => async dispatch => {
  dispatch({ type: CHECK_BAHISTA_ANALYSIS_REQUEST });
  try {
    const data = await checkUserBahistaAnalysisApi(eventId, { customerId });
    dispatch({ type: CHECK_BAHISTA_ANALYSIS_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: CHECK_BAHISTA_ANALYSIS_FAILURE, payload: e });
    throw e;
  }
};

export const fetchBahistaPredictions = (eventId, { preview = false } = {}) => async dispatch => {
  dispatch({ type: GET_BAHISTA_PREDICTIONS_REQUEST });
  try {
    const data = await fetchBahistaPredictionsApi(eventId, { preview });
    dispatch({ type: GET_BAHISTA_PREDICTIONS_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: GET_BAHISTA_PREDICTIONS_FAILURE, payload: e });
    throw e;
  }
};

export const runBahistaAnalyze = (eventId, { isAuthenticated, customerId } = {}) => async dispatch => {
  dispatch({ type: RUN_BAHISTA_ANALYZE_REQUEST });
  try {
    const data = await runBahistaAnalyzeApi(eventId, { isAuthenticated, customerId });
    dispatch({ type: RUN_BAHISTA_ANALYZE_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: RUN_BAHISTA_ANALYZE_FAILURE, payload: e });
    throw e;
  }
};

export const fetchBahistaAuthor = sportId => async (dispatch, getState) => {
  if (sportId == null || sportId === '') return null;
  if (!getState().auth?.isAuthenticated) return null;

  const existing = getState().matchCard?.bahista?.author;
  if (existing && String(existing.sportId) === String(sportId)) {
    return existing;
  }

  dispatch({ type: GET_BAHISTA_AUTHOR_REQUEST });
  try {
    const data = await fetchBahistaAuthorApi(sportId);
    if (!data) {
      dispatch({ type: GET_BAHISTA_AUTHOR_FAILURE });
      return null;
    }
    dispatch({ type: GET_BAHISTA_AUTHOR_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: GET_BAHISTA_AUTHOR_FAILURE, payload: e });
    return null;
  }
};

export const clearBahistaState = () => ({ type: CLEAR_BAHISTA_STATE });
